<script lang="ts">
  // Einheitliches Status-Badge fuer ganz homelab-v2: dezenter Rahmen +
  // getoente Flaeche/Schrift, optional ein fuehrender Punkt. Eckig wie das
  // Schild (--radius-sm), nicht mehr als runde Pille -- Tim 29.09.2026:
  // "Die Rolle ist eher eckig und das andere rund. Ich wuerde das eckige
  // bevorzugen". EIN Ort fuer den
  // Stil -- die alten Punkt+Text-Muster ("● ok") wandern schrittweise hierauf
  // (Tabellen-Standard, docs/tables.md). Gleiche API wie in home-dash.
  import type { Snippet } from "svelte";

  // "info" (blau) statt "accent" (orange) fuer Hinweise: der Akzent ist
  // in diesem Theme orange und liest sich damit als Warnung -- ein
  // Hinweis warnt aber nicht. Gleiche Lesson wie bei den offenen
  // Markierungen: nie --accent fuer eine Einstufung benutzen.
  //
  // Seit 03.10.2026 ist das Schild der EINE Baustein für jeden Zustand,
  // auch den unauffälligen (vorher baute jede Seite ihr leises „ok" als
  // blanken <span> nach):
  //   ok     Normales. Leise, solange in den Einstellungen „nur
  //          Auffälliges" Farbe trägt; grün mit „alles, auch ok"
  //          (Stil .zustand-ok in app.css).
  //   leise  kein Urteil: aus, pausiert, schläft, Kategorie. Immer
  //          blanker Text.
  // `nurAlle` zeigt ein ok-Schild überhaupt nur mit „alles" -- für
  // Stellen, an denen „ok" bisher bewusst gar nicht dastand.
  export type Tone = "ok" | "warn" | "danger" | "neutral" | "accent" | "info" | "leise";
  let {
    tone = "neutral",
    dot = false,
    nurAlle = false,
    class: cls = "",
    children,
  }: { tone?: Tone; dot?: boolean; nurAlle?: boolean; class?: string; children?: Snippet } = $props();

  const toneCls: Record<Exclude<Tone, "leise">, string> = {
    ok: "border-success/30 bg-success/15 text-success",
    warn: "border-warning/40 bg-warning/15 text-warning",
    danger: "border-danger/40 bg-danger/15 text-danger",
    neutral: "border-border bg-fg/5 text-fg-muted",
    accent: "border-laeuft/40 bg-laeuft/15 text-laeuft",
    info: "border-info/40 bg-info/15 text-info",
  };
  const dotCls: Record<Exclude<Tone, "leise">, string> = {
    ok: "bg-success",
    warn: "bg-warning",
    danger: "bg-danger",
    neutral: "bg-fg/30",
    accent: "bg-laeuft",
    info: "bg-info",
  };
</script>

{#if tone === "leise"}
  <span class="text-fg-subtle t-meta {cls}">{@render children?.()}</span>
{:else if tone === "ok"}
  <span class="zustand-ok {nurAlle ? 'nur-alle' : ''} {cls}">
    {#if dot}<span class="zustand-punkt bg-success h-1.5 w-1.5 rounded-full" aria-hidden="true"></span>{/if}
    {@render children?.()}
  </span>
{:else}
  <span
    class="inline-flex shrink-0 items-center gap-1.5 rounded-sm border px-2 py-0.5 t-meta font-medium {toneCls[
      tone
    ]} {cls}"
  >
    {#if dot}<span class="h-1.5 w-1.5 rounded-full {dotCls[tone]}" aria-hidden="true"></span>{/if}
    {@render children?.()}
  </span>
{/if}
